export enum CardFormVariant {
  CREATED = 'CREATED',
  PAYED = 'PAYED',
  REFILLED = 'REFILLED',
}
